import { Api } from '../api';

type WriteWindow = { startTime: string; endTime: string };

export function groupWindowsByDate(
  dates: Api.ClinicianDateAvailability.V[],
): Api.ClinicianDateAvailability.W {
  const windowsByDate = new Map<string, WriteWindow[]>();

  dates.forEach((dateSchedule) => {
    const { date } = dateSchedule;
    if (!date) return;

    const windows = windowsByDate.get(date) ?? [];
    dateSchedule.windows.forEach((window) => {
      const isDuplicate = windows.some(
        (existing) =>
          existing.startTime === window.startTime &&
          existing.endTime === window.endTime,
      );
      if (!isDuplicate) {
        windows.push({ startTime: window.startTime, endTime: window.endTime });
      }
    });
    windowsByDate.set(date, windows);
  });

  return {
    days: Array.from(windowsByDate.entries()).map(([date, windows]) => ({
      date,
      windows,
    })),
  };
}
